import React, { useState } from 'react'
import { extendTheme, Flex } from '@chakra-ui/react'
import { ChakraProvider } from '@chakra-ui/provider'
import { AnimatePresence, motion } from 'framer-motion/dist/es/index'
import LoaderAnimation from './components/LoaderAnimation'
import Header from './components/Header'
import IntroSeciton from './components/IntroSeciton'
import AboutSection from './components/AboutSection'
import ProjectSection from './components/ProjectSection'
import OpenSourceSection from './components/OpenSourceSection'
import FadeInWhenVisible from './components/FadeInWhenVisible'
import { theme } from './theme'

const Theme = extendTheme(theme)

const App = () => {
    const [showLoader, setShowLoader] = useState(true)
    const [showMain, setShowMain] = useState(false)
    setTimeout(() => {
        setShowLoader(false)
        setTimeout(() => {
            setShowMain(true)
        }, 500)
    }, [5500])
    return (
        <ChakraProvider theme={Theme}>
            <Flex w="100%" h="100vh" bg="black" justifyContent="center" alignItems="center">
                <AnimatePresence>
                    {showLoader && <LoaderAnimation />}
                    {showMain &&
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{
                                delay: 0.5,
                                ease: "easeIn"
                            }}
                            style={{ width: "100%", height: "100%", zIndex: 10 }}
                            key="main"
                        >
                            <Flex flexDirection="column" alignItems="center" bg="primary.dark" color="primary.light">
                                <Header />
                                <IntroSeciton />
                                <FadeInWhenVisible>
                                    <AboutSection />
                                </FadeInWhenVisible>
                                <ProjectSection />
                                <OpenSourceSection />
                            </Flex>
                        </motion.div>
                    }
                </AnimatePresence>
            </Flex>
        </ChakraProvider>
    )
}

export default App
